export default __webpack_public_path__ + "static/media/kitchen3-afterK-1440w.8cd52948.png";